const createActionObj = (type, payload) => ({
  type,
  payload
})

const selectAnswer = (question, answer) => createActionObj('SELECT_ANSWER', {question, answer});

const resetAllAnswers = () => createActionObj('RESET_ALL_ANSWERS');

export {
  selectAnswer,
  resetAllAnswers
}